import { useBrandId } from "../../navigation/brands";
import { brandsApi } from "../../services/api/brands";
import FileListTabPage from "../files/FileListTabPage";

export default function BrandFilesTabPage() {
    return <FileListTabPage api={brandsApi.files} ownerId={useBrandId()} />;
}
